import React from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core/styles';
import { Grid, Box } from '@material-ui/core';
import clsx from 'clsx';

import {
  Button, Link, IntercomComponent,
} from '../../components';
import VideoIframe from '../../components/video-iframe/VideoIframe';

import {
  VideoIcon,
  FilmIcon,
  PlayCircleIcon,
  CalendarAltIcon,
  CommentIcon,
  PhoneIcon,
  NewspaperIcon,
  EnvelopeIcon,
} from '../../components/icon/solid';
import createImage from '../../assets/img/landing/create_01.png';
import produceImage from '../../assets/img/landing/produce_01.png';
import publishImage from '../../assets/img/landing/publish_01.png';
import aragonHotVendor2020 from '../../assets/img/landing/Aragon-Research-Hot-Vendor-2020-Transparent.png';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  imageShowcase: {
    padding: '0px 20px',
    width: '95%',
    minWidth: '300px',
    maxWidth: '700px',
  },
  imageResearch: {
    padding: '0px 20px',
    width: '95%',
    minWidth: '150px',
    maxWidth: '200px',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
  },
  wrapper: {
    height: '100%',
    width: '100%',
  },
  wrapperBottomPadding: {
    paddingBottom: '20px',
  },
  backgroundVideo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    verticalAlign: 'middle',
    bottom: 0,
    width: '100%',
    height: '100%',
    background: '#FFF',
    overflow: 'hidden',
    zIndex: 1,
  },
  contentBackgroundVideo: {
    margin: 'auto',
    zIndex: 1,
  },
  title: {
    color: '#26325F',
    fontFamily: 'Montserrat',
    fontSize: '40px',
    fontWeight: 800,
    letterSpacing: '0.52px',
    maxWidth: '650px',
    textAlign: 'center',
  },
  smallTitle: {
    marginTop: '20px',
    color: '#26325F',
    fontFamily: 'Montserrat',
    fontSize: '22px',
    fontWeight: 'bold',
    letterSpacing: '0.29px',
    maxWidth: '620px',
    textAlign: 'center',
  },
  researchReportText: {
    textAlign: 'center',
    fontStyle: 'italic',
    paddingBottom: '20px'
  },
  buttonContainer: {
    marginTop: '50px',
    textAlign: 'center',
  },
  button: {
    height: '48px',
    width: '190px',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    fontSize: '16px',
    fontFamily: 'Montserrat, sans',
    fontWeight: 600,
    padding: '5px 20px',
    margin: '0 20px',
    boxShadow: 'none',
    letterSpacing: '0.21px',
  },
  buttonRegister: {
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  buttonPricing: {
    color: '#FFF',
    background: palette.buttonSingle.color,
    '&:hover': {
      backgroundColor: palette.buttonSingle.color,
    },
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  titleBlue: {
    textAlign: 'center',
    fontSize: '36px',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    color: '#26325F',
    marginTop: '100px',
    marginBottom: '20px',
  },
  titleBlueSecondary: {
    fontSize: '36px',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    color: '#26325F',
    margin: '5px 0 10px 0',
  },
  titleSmallBlue: {
    textAlign: 'center',
    fontSize: '16px',
  },
  text: {
    fontSize: '22px',
    textAlign: 'center',
    color: '#26325F',
    fontFamily: 'Montserrat',
  },
  textBox: {
    maxWidth: '620px',
    margin: 'auto',
  },
  icon: {
    height: '48px',
    width: '48px',
    margin: 'auto',
  },
  videoIcon: {
    color: '#0B72D5',
  },
  filmIcon: {
    color: '#FF6C00',
  },
  playIcon: {
    color: '#00AD8D',
  },
  iconTitle: {
    fontSize: '22px',
    fontWeight: 'bold',
    margin: '20px 0 0 0',
  },
  iconWrapper: {
    textAlign: 'center',
    minWidth: '200px',
    fontSize: '16px',
  },
  center: {
    textAlign: 'center',
  },
  list: {
    fontSize: '16px',
    padding: '16px 0 0 0',
  },
  list2: {
    fontSize: '16px',
    padding: '2px 0 0 0',
  },
  list3: {
    fontSize: '16px',
    padding: '2px 0 0 0',
  },
  margin: {
    margin: '50px 0 50px 0',
  },
  background: {
    background: '#F1F2F5',
  },
  imageContainer: {
    display: 'inline-block',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  contactContainer: {
    fontSize: 22,
  },
  contactLink: {
    marginBottom: 10,
  },
  contactIcon: {
    color: '#01B3C5',
    display: 'flex',
  },
  container: {
    maxWidth: 1280,
    margin: 'auto',
  },
}), { name: 'Landing' });

const Landing = () => {
  const classes = useStyles();

  const debug = false;
  const videoUrl = debug ? 'http://localhost:8000/en/public/player/iframe/773cc30eed27c2514060967fc0da5837'
    : 'https://player.pitchhub.com/en/public/player/iframe/b6ea4394c8bd9da95b0adbb1a7edda7c';

  return (
    <div className={classes.root}>

      <div className={classes.wrapper}>
        <div className={classes.backgroundVideo}>
          <div className={classes.contentBackgroundVideo}>
            <div className={classes.title}>
              Professional Videos Made Easy
            </div>
            <div className={classes.smallTitle}>
              Turn key video production for business professionals
            </div>
          </div>
          <VideoIframe src={videoUrl} title="PitchHub" />
          <Grid item container xs={12} sm={6} alignItems="center" justify="center">
            <Link
              defaultAction
              to="https://blog.pitchhub.com/email-newsletter-signup/"
              target="_blank"
            >
              <img src={aragonHotVendor2020} alt="Aragon Research 2020 Hot Vendor" className={classes.imageResearch} />
            </Link>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sm={6}
            alignItems="center"
            justify="center"
            className={classes.researchReportText}
          >
          </Grid>
        </div>
      </div>
      <div className={classes.wrapper}>
        <h1 className={classes.titleBlue}>Turnkey Video Production</h1>
        <Grid container justify="center">
          <Grid item className={classes.iconWrapper}>
            <VideoIcon className={clsx(classes.icon, classes.videoIcon)} />
            <p className={clsx(classes.iconTitle, classes.center)}>Create</p>
            <p>
              Video production
              <br />
              &nbsp;simplified
            </p>
          </Grid>
          <Grid item className={classes.iconWrapper}>
            <FilmIcon className={clsx(classes.icon, classes.filmIcon)} />
            <p className={clsx(classes.iconTitle, classes.center)}>Produce</p>
            <p>Professional editing</p>
          </Grid>
          <Grid item className={classes.iconWrapper}>
            <PlayCircleIcon className={clsx(classes.icon, classes.playIcon)} />
            <p className={clsx(classes.iconTitle, classes.center)}>Publish</p>
            <p>Easy distribution</p>
          </Grid>
        </Grid>
      </div>
      <Grid container className={classes.background}>
        <Grid item container className={classes.container} spacing={2}>
          <Grid container item xs={12} className={classes.margin}>
            <Grid item container xs={12} sm={6} alignItems="center" justify="center">
              <img src={createImage} alt="Create" className={classes.imageShowcase} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <p className={clsx(classes.iconTitle, classes.videoIcon)}>Create</p>
              <h1 className={classes.titleBlueSecondary}>Video production simplified</h1>
              <ul>
                <li className={classes.list}>
                  Use PitchHub&reg; templates to easily create online videos for social media,
                  real estate, enterprise and branding
                </li>
                <ul>
                  <li className={classes.list2}>Online videos for social media</li>
                  <li className={classes.list2}>Real Estate</li>
                  <li className={classes.list2}>Enterprise</li>
                  <li className={classes.list2}>Branding</li>
                </ul>
                {/* Showing trademark (TM) important for trademark approval */}
                <li className={classes.list}>Use ClipPress&trade; software to plan each scene’s:</li>
                <ul>
                  <li className={classes.list2}>Script</li>
                  <li className={classes.list2}>Transitions</li>
                  <li className={classes.list2}>Photos</li>
                  <li className={classes.list2}>Graphics</li>
                </ul>
                <li className={classes.list}>Record video sections &quot;with teleprompter&quot;</li>
                <ul>
                  <li className={classes.list2}>Smart phone</li>
                  <li className={classes.list2}>Tablet</li>
                  <li className={classes.list2}>Another camera while using our teleprompter</li>
                </ul>
              </ul>
            </Grid>
          </Grid>
          <Grid container item xs={12} className={classes.margin}>
            <Grid item container xs={12} sm={6} alignItems="center" justify="center">
              <img src={produceImage} alt="Produce" className={classes.imageShowcase} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <p className={clsx(classes.iconTitle, classes.filmIcon)}>Produce</p>
              <h1 className={classes.titleBlueSecondary}>Professional editing</h1>
              <ul>
                <li className={classes.list}>Video editor options:</li>
                <ul>
                  {/* Showing Registered trademark (R) important for trademark approval */}
                  <li className={classes.list2}>Use PitchHub&reg;</li>
                  <li className={classes.list2}>Use your own editor</li>
                  <li className={classes.list2}>We can recommend many options.. just ask us!</li>
                </ul>
                <li className={classes.list}>
                  Eliminate emails to coordinate--all of the instructions and content is
                  already stored in PitchHub!
                </li>
                <li className={classes.list}>Review drafts and comment until the video is ready to publish</li>
              </ul>
            </Grid>
          </Grid>
          <Grid container item xs={12} className={classes.margin}>
            <Grid item container xs={12} sm={6} alignItems="center" justify="center">
              <img src={publishImage} alt="Publish" className={classes.imageShowcase} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <p className={clsx(classes.iconTitle, classes.playIcon)}>Publish</p>
              <h1 className={classes.titleBlueSecondary}>Easy distribution</h1>
              <ul>
                <li className={classes.list}>Download MP4&apos;s of the edited videos in 3 quality sizes</li>
                <li className={classes.list}>
                  Upload to your favorite sites such as LinkedIn, Facebook, Instagram, Vimeo, and YouTube
                </li>
                <ul>
                  <li className={classes.list2}>LinkedIn</li>
                  <li className={classes.list2}>Facebook</li>
                  <li className={classes.list2}>Instagram</li>
                  <li className={classes.list2}>Vimeo</li>
                  <li className={classes.list2}>YouTube</li>
                </ul>
                {/* Showing Registered trademark (R) important for trademark approval */}
                <li className={classes.list}>
                  PitchHub&reg; can also host your video, so you can avoid commercials or fees
                  from other video services
                </li>
              </ul>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <div className={clsx(classes.wrapper, classes.wrapperBottomPadding)}>
        <h1 className={clsx(classes.titleBlue)}>
          Take your business to
          <br />
          &nbsp;the next level with video
        </h1>
        <p className={clsx(classes.textBox, classes.text)}>
          Produce like a pro and connect
          <br />
          &nbsp;with your customers like never before
        </p>
        <div className={classes.buttonContainer}>
          <Link to="/pages/pricing" className={classes.buttonLink}>
            <Button
              variant="contained"
              className={clsx(classes.button, classes.buttonPricing)}
            >
              View pricing
            </Button>
          </Link>
          <Link to="/pages/register" className={classes.buttonLink}>
            <Button
              color="primary"
              variant="contained"
              className={clsx(classes.button, classes.buttonRegister)}
            >
              Try for free!
            </Button>
          </Link>
        </div>
      </div>
      <Grid
        container
        className={clsx(classes.background, classes.contactContainer)}
        justify="center"
        alignContent="center"
        alignItems="center"
      >
        <Grid item container className={classes.container}>
          <Grid item container justify="center">
            <h1 id="contact" className={classes.titleBlue}>Contact Sales</h1>
          </Grid>
          <Grid item container justify="center" alignItems="center" className={classes.contactLink}>
            <Box mr={1}>
              <CalendarAltIcon className={classes.contactIcon} />
            </Box>
            <Link
              defaultAction
              to="https://meetings.hubspot.com/andrew-devlin"
              target="_blank"
            >
              Book a meeting
            </Link>
          </Grid>
          <Grid item container justify="center" alignItems="center" className={classes.contactLink}>
            <Box mr={1}>
              <NewspaperIcon className={classes.contactIcon} />
            </Box>
            <Link
              defaultAction
              to="https://blog.pitchhub.com/email-newsletter-signup/"
              target="_blank"
            >
              Signup for our newsletter
            </Link>
          </Grid>
          <Grid item container justify="center" alignItems="center" className={classes.contactLink}>
            <Box mr={1}>
              <EnvelopeIcon className={classes.contactIcon} />
            </Box>
            <Link
              defaultAction
              to="mailto:info@pitchhub.com"
              target="_blank"
            >
              info@pitchhub.com
            </Link>
          </Grid>
          <Grid item container justify="center" alignItems="center" className={classes.contactLink}>
            <Box mr={1}>
              <PhoneIcon className={classes.contactIcon} />
            </Box>
            <Link
              defaultAction
              to="tel:+14086568247"
              target="_blank"
            >
              (408)656-8247
            </Link>
          </Grid>
          <Grid item container justify="center" alignItems="center" className={classes.contactLink}>
            <Box mr={1}>
              <CommentIcon className={classes.contactIcon} />
            </Box>
            <Link
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                e.preventDefault();
                if (window.Intercom) {
                  window.Intercom('show');
                }
              }}
            >
              Chat with us
            </Link>
          </Grid>
        </Grid>
      </Grid>
      <div style={{ height: '100px', width: '100%' }} className={classes.background} />
      <IntercomComponent />
    </div>
  );
};

export default Landing;
